import { defineStore } from "pinia";
import BaseCalls from "@/services/BaseCalls.js";

export const useUserStore = defineStore("user", {
  state: () => ({
    userData: null,
    isLogged: false,
    loaded: false,
  }),
  getters: {
    isAdmin: (state) =>
      !!state.userData && Number(state.userData.user_is_admin) === 1,
  },
  actions: {
    setUser(data) {
      this.userData = data || null;
      this.isLogged = !!data;
    },
    async fetchLoggedUser() {
      try {
        const r = await BaseCalls.userGet({ action: "loggeduser" });
        const user = r?.data?.user || null;
        this.setUser(user && user.user_id ? user : null);
      } catch (_e) {
        this.setUser(null);
      } finally {
        this.loaded = true;
      }
      return this.userData;
    },
    async login(email, password) {
      const r = await BaseCalls.userPost({
        action: "startlogin",
        user_email: email,
        user_password: password,
      });
      if (r?.data?.success && r?.data?.user) {
        this.setUser(r.data.user);
        return { success: true, user: r.data.user };
      }
      return {
        success: false,
        message: r?.data?.message || "Anmeldung fehlgeschlagen",
      };
    },
    async logout() {
      try {
        await BaseCalls.userGet({ action: "logout" });
      } catch (_e) {
        /* ignore */
      }
      this.setUser(null);
    },
  },
});
